/* eslint no-shadow: ['error', { 'allow': ['state'] }] */
import { VehicleSelectionFrom } from '../../constants/analytics';

const ACTIVITY_KEY = 'activityTracking';

export const state = {
    activity: {
        lookupMethod: null,
        lookupUuid: null,
        pdpFromPage: null,
        pdpFromResultsPage: null,
        pdpFromResultsIndex: null,
        searchPerformed: false,
        searchTerm: '',
        partsLookupStartTime: 0,
        partsLookupEndTime: 0,
        vehicleAddedFrom: VehicleSelectionFrom.OTHER,
    },
};

export const mutations = {
    setActivity(state, payload) {
        state.activity = { ...state.activity, ...payload };
        sessionStorage.setItem(ACTIVITY_KEY, JSON.stringify(state.activity));
    },
};

export const getters = {
    lookupDuration(state) {
        const { lookupStartTime, lookupEndTime } = state.activity;
        const duration = lookupEndTime - lookupStartTime;

        return duration;
    },
};

export const actions = {
    startPartsLookupTimer({ commit }) {
        commit('setActivity', { lookupStartTime: Date.now() });
    },
    stopPartsLookupTimer({ commit }) {
        commit('setActivity', { lookupEndTime: Date.now() });
    },
    getActivityTracking({ commit }) {
        const activity = sessionStorage.getItem(ACTIVITY_KEY);

        commit('setActivity', activity ? JSON.parse(activity) : {});
    },
    setSearchUuid({ commit }, newUuid) {
        commit('setActivity', { lookupUuid: newUuid ?? crypto.randomUUID() });
    },
    setLookupMethod({ commit }, method) {
        commit('setActivity', { lookupMethod: method });
    },
    setPDPViewFrom({ commit, state }, pdpFromPage) {
        commit('setActivity', { ...state.activity, pdpFromPage });
    },
    setPDPResultsPageFrom({ commit, state }, pdpFromResultsPage) {
        commit('setActivity', { ...state.activity, pdpFromResultsPage });
    },
    setPDPResultsIndexFrom({ commit, state }, pdpFromResultsIndex) {
        commit('setActivity', { ...state.activity, pdpFromResultsIndex });
    },
    resetPDPView({ commit }) {
        commit('setActivity', { ...state.activity, pdpFromPage: null, pdpFromResultsPage: null, pdpFromResultsIndex: null });
    },
    setLastQuoteVisited({ commit }, lastQuoteVisited) {
        commit('setActivity', { lastQuoteVisited });
    },
    setAuthAttemptedLoginName({ commit }, authAttemtedLoginName) {
        commit('setActivity', { authAttemtedLoginName });
    },
    setSearchPerformed({ commit }, searchPerformed) {
        commit('setActivity', { searchPerformed });
    },
    setSearchTerm({ commit }, searchTerm) {
        commit('setActivity', { searchTerm });
    },
    resetSearchData({ commit }) {
        commit('setActivity', { searchPerformed: false, searchTerm: '' });
    },
    setVehicleAddedFrom({ commit, state }, vehicleAddedFrom) {
        commit('setActivity', { ...state.activity, vehicleAddedFrom });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
